import { MouseEvent, ReactNode, useState } from 'react';
import { IconButton, IIconButton } from '@components/iconButton';
import { Menu, IMenuItem } from '@components/menu/Menu';

interface IMenuButton {
  items: IMenuItem[];
  icon: ReactNode;
  onCloseMenu?: () => void;
  iconButtonProps?: IIconButton;
}

export const MenuButton = (props: IMenuButton) => {
  const { items, icon, onCloseMenu, iconButtonProps } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleOnOpenMenu = (event: MouseEvent<HTMLElement | null>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOnCloseMenu = () => {
    setAnchorEl(null);
    if (typeof onCloseMenu === 'function') {
      onCloseMenu();
    }
  };

  const handleOnClickMenuItem = (index: number) => {
    handleOnCloseMenu();
    items[index]?.action?.();
  };

  return (
    <>
      <IconButton
        id='open-menu-button'
        aria-controls={openMenu ? 'actions-menu' : undefined}
        aria-expanded={openMenu ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleOnOpenMenu}
        {...iconButtonProps}
      >
        {icon}
      </IconButton>

      <Menu
        id='actions-menu'
        aria-labelledby='open-menu-button'
        open={openMenu}
        anchorEl={anchorEl}
        items={items}
        onClickMenuItem={handleOnClickMenuItem}
        onClose={handleOnCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      />
    </>
  );
};
